export const DISCORD_LINK = 'https://discord.gg/wTJ7besU';
export const FIGMA_LINK =
  'https://www.figma.com/community/file/1370194397345450683/onchainkit';
export const GITHUB_LINK = 'https://github.com/coinbase/onchainkit';
export const ONCHAINKIT_LINK = 'https://onchainkit.xyz';
export const TELEGRAM_LINK = 'https://t.me/baseboomerportal';
export const TWITTER_LINK = 'https://twitter.com/BoomerOnBase';
export const MERCH_LINK = 'https://baseboomermerch.com/';
export const WEBSITE_LINK = 'https://baseboomer.com/';
export const BUY_BOOMER_LINK =
  'https://swap.defillama.com/?chain=base&from=0x0000000000000000000000000000000000000000&tab=swap&to=0xcde172dc5ffc46d228838446c57c1227e0b82049';
